export default {"src":"/sg/_next/static/media/CathedralTrain.19b3f5a8.svg","height":150,"width":110,"blurWidth":0,"blurHeight":0};